<template>
  <img
    id="burger-nav"
    src="https://cdn.karier.mu/assets/v3/icon/icon-bars.svg"
    alt="burger-nav"
    class="burger-nav"
    @click="toggleBurgerNav()"
  >
</template>

<script>
export default {
  name: 'BurgerNavigation',
  props: {
    isOpen: Boolean
  },
  methods: {
    toggleBurgerNav () {
      this.$emit('toggleBurgerNav')
    }
  }
}
</script>

<style scoped>
.burger-nav {
  width: 24px;
  height: 24px;
}
</style>
